export default __webpack_public_path__ + "static/media/Takeaway.abb96f8f.svg";